module.exports = __webpack_public_path__ + "static/media/2.d92d4fd5.jpg";